"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oidc = exports.getLoginParams = void 0;
var appauth_1 = require("@openid/appauth");
var noHashQueryStringUtils_1 = require("./noHashQueryStringUtils");
var initWorker_1 = require("./initWorker");
var memoryStorageBackend_1 = require("./memoryStorageBackend");
var initSession_1 = require("./initSession");
var timer_1 = __importDefault(require("./timer"));
var isInIframe = function () {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
var idTokenPayload = function (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
};
var countLetter = function (str, find) {
    return (str.split(find)).length - 1;
};
var extractAccessTokenPayload = function (tokens) {
    if (tokens.accessTokenPayload) {
        return tokens.accessTokenPayload;
    }
    var accessToken = tokens.accessToken;
    try {
        if (!accessToken || countLetter(accessToken, '.') != 2) {
            return null;
        }
        return JSON.parse(atob(accessToken.split('.')[1]));
    }
    catch (e) {
        console.warn(e);
    }
    return null;
};
var oidcDatabase = {};
var oidcFactory = function (configuration, name) {
    if (name === void 0) { name = "default"; }
    if (oidcDatabase[name]) {
        return oidcDatabase[name];
    }
    oidcDatabase[name] = new Oidc(configuration, name);
    return oidcDatabase[name];
};
var loginCallbackWithAutoTokensRenewAsync = function (oidc) { return __awaiter(void 0, void 0, void 0, function () {
    var response, tokens, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, oidc.loginCallbackAsync()];
            case 1:
                response = _b.sent();
                tokens = response.tokens;
                _a = oidc;
                return [4 /*yield*/, setTokensAsync(oidc.serviceWorker, tokens)];
            case 2:
                _a.tokens = _b.sent();
                if (!!oidc.serviceWorker) return [3 /*break*/, 4];
                return [4 /*yield*/, oidc.session.setTokens(oidc.tokens)];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4:
                oidc.publishEvent(Oidc.eventNames.token_aquired, oidc.tokens);
                oidc.timeoutId = autoRenewTokens(oidc, tokens.refreshToken, oidc.tokens.expiresAt);
                return [2 /*return*/, { state: response.state, callbackPath: response.callbackPath }];
        }
    });
}); };
var autoRenewTokens = function (oidc, refreshToken, expiresAt) {
    var _a;
    var refreshTimeBeforeTokensExpirationInSecond = (_a = oidc.configuration.refresh_time_before_tokens_expiration_in_second) !== null && _a !== void 0 ? _a : 60;
    return timer_1.default.setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentTimeUnixSecond, timeInfo, tokens, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentTimeUnixSecond = new Date().getTime() / 1000;
                    timeInfo = { timeLeft: Math.round(((expiresAt - refreshTimeBeforeTokensExpirationInSecond) - currentTimeUnixSecond)) };
                    oidc.publishEvent(Oidc.eventNames.token_timer, timeInfo);
                    if (!(currentTimeUnixSecond > (expiresAt - refreshTimeBeforeTokensExpirationInSecond))) return [3 /*break*/, 5];
                    return [4 /*yield*/, oidc.refreshTokensAsync(refreshToken)];
                case 1:
                    tokens = _b.sent();
                    _a = oidc;
                    return [4 /*yield*/, setTokensAsync(oidc.serviceWorker, tokens)];
                case 2:
                    _a.tokens = _b.sent();
                    if (!!oidc.serviceWorker) return [3 /*break*/, 4];
                    return [4 /*yield*/, oidc.session.setTokens(oidc.tokens)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    if (!oidc.tokens) {
                        return [2 /*return*/];
                    }
                    oidc.publishEvent(Oidc.eventNames.token_renewed, oidc.tokens);
                    if (oidc.timeoutId) {
                        oidc.timeoutId = autoRenewTokens(oidc, tokens.refreshToken, oidc.tokens.expiresAt);
                    }
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, oidc.syncTokensAsync()];
                case 6:
                    _b.sent();
                    if (oidc.timeoutId) {
                        oidc.timeoutId = autoRenewTokens(oidc, refreshToken, expiresAt);
                    }
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); }, 1000);
};
var getLoginParams = function (configurationName) {
    return JSON.parse(sessionStorage["oidc_login.".concat(configurationName)]);
};
exports.getLoginParams = getLoginParams;
var userInfoAsync = function (oidc) { return __awaiter(void 0, void 0, void 0, function () {
    var accessToken, oidcServerConfiguration, url, fetchUserInfo, userInfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (oidc.userInfo != null) {
                    return [2 /*return*/, oidc.userInfo];
                }
                if (!oidc.tokens) {
                    return [2 /*return*/, null];
                }
                if (!oidc.syncTokensAsyncPromise) return [3 /*break*/, 2];
                return [4 /*yield*/, oidc.syncTokensAsyncPromise];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2:
                accessToken = oidc.tokens.accessToken;
                return [4 /*yield*/, oidc.initAsync(oidc.configuration.authority, oidc.configuration.authority_configuration)];
            case 3:
                oidcServerConfiguration = _a.sent();
                url = oidcServerConfiguration.userInfoEndpoint;
                fetchUserInfo = function (accessToken) { return __awaiter(void 0, void 0, void 0, function () {
                    var res;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, fetch(url, {
                                    headers: {
                                        authorization: "Bearer ".concat(accessToken)
                                    }
                                })];
                            case 1:
                                res = _a.sent();
                                if (res.status != 200) {
                                    return [2 /*return*/, null];
                                }
                                return [2 /*return*/, res.json()];
                        }
                    });
                }); };
                return [4 /*yield*/, fetchUserInfo(accessToken)];
            case 4:
                userInfo = _a.sent();
                oidc.userInfo = userInfo;
                return [2 /*return*/, userInfo];
        }
    });
}); };
var setTokensAsync = function (serviceWorker, tokens) { return __awaiter(void 0, void 0, void 0, function () {
    var accessTokenPayload, expiresAt;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(tokens == null)) return [3 /*break*/, 3];
                if (!serviceWorker) return [3 /*break*/, 2];
                return [4 /*yield*/, serviceWorker.clearAsync()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, null];
            case 3:
                if (!serviceWorker) return [3 /*break*/, 5];
                return [4 /*yield*/, serviceWorker.getAccessTokenPayloadAsync()];
            case 4:
                accessTokenPayload = _a.sent();
                return [3 /*break*/, 6];
            case 5:
                accessTokenPayload = extractAccessTokenPayload(tokens);
                _a.label = 6;
            case 6:
                expiresAt = tokens.issuedAt + tokens.expiresIn;
                return [2 /*return*/, __assign(__assign({}, tokens), { idTokenPayload: idTokenPayload(tokens.idToken), accessTokenPayload: accessTokenPayload, expiresAt: expiresAt })];
        }
    });
}); };
var eventNames = {
    service_worker_not_supported_by_browser: "service_worker_not_supported_by_browser",
    token_aquired: "token_aquired",
    token_renewed: "token_renewed",
    token_timer: "token_timer",
    loginAsync_begin: "loginAsync_begin",
    loginAsync_error: "loginAsync_error",
    loginCallbackAsync_begin: "loginCallbackAsync_begin",
    loginCallbackAsync_end: "loginCallbackAsync_end",
    loginCallbackAsync_error: "loginCallbackAsync_error",
    refreshTokensAsync_begin: "refreshTokensAsync_begin",
    refreshTokensAsync_end: "refreshTokensAsync_end",
    refreshTokensAsync_error: "refreshTokensAsync_error",
    refreshTokensAsync_silent_begin: "refreshTokensAsync_silent_begin",
    refreshTokensAsync_silent_end: "refreshTokensAsync_silent_end",
    refreshTokensAsync_silent_error: "refreshTokensAsync_silent_error",
    tryKeepExistingSessionAsync_begin: "tryKeepExistingSessionAsync_begin",
    tryKeepExistingSessionAsync_end: "tryKeepExistingSessionAsync_end",
    tryKeepExistingSessionAsync_error: "tryKeepExistingSessionAsync_error",
    silentSigninAsync_begin: "silentSigninAsync_begin",
    silentSigninAsync: "silentSigninAsync",
    silentSigninAsync_end: "silentSigninAsync_end",
    silentSigninAsync_error: "silentSigninAsync_error",
    syncTokensAsync_begin: "syncTokensAsync_begin",
    syncTokensAsync_end: "syncTokensAsync_end",
    syncTokensAsync_error: "syncTokensAsync_error"
};
var getRandomInt = function (max) {
    return Math.floor(Math.random() * max);
};
var Oidc = /** @class */ (function () {
    function Oidc(configuration, configurationName) {
        if (configurationName === void 0) { configurationName = "default"; }
        this.initAsyncPromise = null;
        this.tryKeepExistingSessionPromise = null;
        this.syncTokensAsyncPromise = null;
        this.loginCallbackWithAutoTokensRenewPromise = null;
        this.configuration = configuration;
        this.configurationName = configurationName;
        this.tokens = null;
        this.userInfo = null;
        this.events = [];
        this.timeoutId = null;
        this.serviceWorker = null;
        this.session = null;
        this.refreshTokensAsync.bind(this);
        this.loginCallbackWithAutoTokensRenewAsync.bind(this);
        this.initAsync.bind(this);
        this.loginCallbackAsync.bind(this);
        this.subscriveEvents.bind(this);
        this.removeEventSubscription.bind(this);
        this.publishEvent.bind(this);
        this.destroyAsync.bind(this);
    }
    Oidc.prototype.subscriveEvents = function (func) {
        var id = getRandomInt(9999999999999).toString();
        this.events.push({ id: id, func: func });
        return id;
    };
    Oidc.prototype.removeEventSubscription = function (id) {
        var newEvents = this.events.filter(function (e) { return e.id !== id; });
        this.events = newEvents;
    };
    Oidc.prototype.publishEvent = function (eventName, data) {
        this.events.forEach(function (event) {
            event.func(eventName, data);
        });
    };
    Oidc.getOrCreate = function (configuration, name) {
        if (name === void 0) { name = "default"; }
        return oidcFactory(configuration, name);
    };
    Oidc.get = function (name) {
        if (name === void 0) { name = "default"; }
        var insideBrowser = (typeof process === 'undefined');
        if (!oidcDatabase.hasOwnProperty(name) && insideBrowser) {
            throw Error("Oidc library does seem initialized.\nPlease checkout that you are using OIDC hook inside a <OidcProvider configurationName=\"".concat(name, "\"></OidcProvider> compoment."));
        }
        return oidcDatabase[name];
    };
    Oidc.prototype.silentSigninCallbackFromIFrame = function () {
        if (this.configuration.silent_redirect_uri) {
            window.top.postMessage("".concat(this.configurationName, "_oidc_tokens:").concat(JSON.stringify(this.tokens)), window.location.origin);
        }
    };
    Oidc.prototype.silentSigninAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var configuration_1, link, iframe_1, self_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.configuration.silent_redirect_uri) {
                            return [2 /*return*/, Promise.resolve(null)];
                        }
                        _a.label = 1;
                    case 1:
                        if (!document.hidden) return [3 /*break*/, 3];
                        return [4 /*yield*/, (0, initWorker_1.sleepAsync)(1000)];
                    case 2:
                        _a.sent();
                        this.publishEvent(eventNames.silentSigninAsync, { message: "wait because document is hidden" });
                        return [3 /*break*/, 1];
                    case 3:
                        try {
                            this.publishEvent(eventNames.silentSigninAsync_begin, {});
                            configuration_1 = this.configuration;
                            link = configuration_1.silent_redirect_uri;
                            iframe_1 = document.createElement('iframe');
                            iframe_1.width = "0px";
                            iframe_1.height = "0px";
                            iframe_1.id = "".concat(this.configurationName, "_oidc_iframe");
                            iframe_1.setAttribute("src", link);
                            document.body.appendChild(iframe_1);
                            self_1 = this;
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    try {
                                        var isResolved_1 = false;
                                        window.onmessage = function (e) {
                                            var key = "".concat(self_1.configurationName, "_oidc_tokens:");
                                            if (e.data && typeof (e.data) === "string" && e.data.startsWith(key)) {
                                                if (!isResolved_1) {
                                                    var result = JSON.parse(e.data.replace(key, ''));
                                                    self_1.publishEvent(eventNames.silentSigninAsync_end, result);
                                                    iframe_1.remove();
                                                    isResolved_1 = true;
                                                    resolve(result);
                                                }
                                            }
                                        };
                                        var silentSigninTimeout = configuration_1.silent_signin_timeout ? configuration_1.silent_signin_timeout : 12000;
                                        setTimeout(function () {
                                            if (!isResolved_1) {
                                                self_1.publishEvent(eventNames.silentSigninAsync_error, "timeout");
                                                iframe_1.remove();
                                                isResolved_1 = true;
                                                reject("timeout");
                                            }
                                        }, silentSigninTimeout);
                                    }
                                    catch (e) {
                                        iframe_1.remove();
                                        self_1.publishEvent(eventNames.silentSigninAsync_error, e);
                                        reject(e);
                                    }
                                })];
                        }
                        catch (e) {
                            this.publishEvent(eventNames.silentSigninAsync_error, e);
                            throw e;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Oidc.prototype.initAsync = function (authority, authorityConfiguration) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (authorityConfiguration != null) {
                            return [2 /*return*/, new appauth_1.AuthorizationServiceConfiguration({
                                    authorization_endpoint: authorityConfiguration.authorization_endpoint,
                                    end_session_endpoint: authorityConfiguration.end_session_endpoint,
                                    revocation_endpoint: authorityConfiguration.revocation_endpoint,
                                    token_endpoint: authorityConfiguration.token_endpoint,
                                    userinfo_endpoint: authorityConfiguration.userinfo_endpoint
                                })];
                        }
                        if (this.initAsyncPromise) {
                            return [2 /*return*/, this.initAsyncPromise];
                        }
                        _a = this;
                        return [4 /*yield*/, appauth_1.AuthorizationServiceConfiguration.fetchFromIssuer(authority, new appauth_1.FetchRequestor())];
                    case 1:
                        _a.initAsyncPromise = _b.sent();
                        return [2 /*return*/, this.initAsyncPromise];
                }
            });
        });
    };
    Oidc.prototype.tryKeepExistingSessionAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var funcAsync;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.tryKeepExistingSessionPromise !== null) {
                    return [2 /*return*/, this.tryKeepExistingSessionPromise];
                }
                funcAsync = function () { return __awaiter(_this, void 0, void 0, function () {
                    var serviceWorker, configuration, oidcServerConfiguration, tokens, updatedTokens, _a, session, tokens, updatedTokens, _b, exception_1;
                    var _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                if (this.tokens != null) {
                                    return [2 /*return*/, false];
                                }
                                this.publishEvent(eventNames.tryKeepExistingSessionAsync_begin, {});
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 13, , 16]);
                                configuration = this.configuration;
                                return [4 /*yield*/, this.initAsync(configuration.authority, configuration.authority_configuration)];
                            case 2:
                                oidcServerConfiguration = _d.sent();
                                return [4 /*yield*/, (0, initWorker_1.initWorkerAsync)(configuration.service_worker_relative_url, this.configurationName)];
                            case 3:
                                serviceWorker = _d.sent();
                                if (!serviceWorker) return [3 /*break*/, 8];
                                return [4 /*yield*/, serviceWorker.initAsync(oidcServerConfiguration, "tryKeepExistingSessionAsync")];
                            case 4:
                                tokens = (_d.sent()).tokens;
                                if (!tokens) return [3 /*break*/, 7];
                                serviceWorker.startKeepAliveServiceWorker();
                                return [4 /*yield*/, this.refreshTokensAsync(tokens.refresh_token, true)];
                            case 5:
                                updatedTokens = _d.sent();
                                // @ts-ignore
                                _a = this;
                                return [4 /*yield*/, setTokensAsync(serviceWorker, updatedTokens)];
                            case 6:
                                // @ts-ignore
                                _a.tokens = _d.sent();
                                this.serviceWorker = serviceWorker;
                                // @ts-ignore
                                this.timeoutId = autoRenewTokens(this, updatedTokens.refreshToken, this.tokens.expiresAt);
                                this.publishEvent(eventNames.tryKeepExistingSessionAsync_end, {
                                    success: true,
                                    message: "tokens inside ServiceWorker are valid"
                                });
                                return [2 /*return*/, true];
                            case 7:
                                this.publishEvent(eventNames.tryKeepExistingSessionAsync_end, {
                                    success: false,
                                    message: "no exiting session found"
                                });
                                return [3 /*break*/, 12];
                            case 8:
                                if (configuration.service_worker_relative_url) {
                                    this.publishEvent(eventNames.service_worker_not_supported_by_browser, {
                                        message: "service worker is not supported by this browser"
                                    });
                                }
                                session = (0, initSession_1.initSession)(this.configurationName, (_c = configuration.storage) !== null && _c !== void 0 ? _c : sessionStorage);
                                return [4 /*yield*/, session.initAsync()];
                            case 9:
                                tokens = (_d.sent()).tokens;
                                if (!tokens) return [3 /*break*/, 12];
                                return [4 /*yield*/, this.refreshTokensAsync(tokens.refreshToken, true)];
                            case 10:
                                updatedTokens = _d.sent();
                                // @ts-ignore
                                _b = this;
                                return [4 /*yield*/, setTokensAsync(serviceWorker, updatedTokens)];
                            case 11:
                                // @ts-ignore
                                _b.tokens = _d.sent();
                                session.setTokens(this.tokens);
                                this.session = session;
                                // @ts-ignore
                                this.timeoutId = autoRenewTokens(this, updatedTokens.refreshToken, this.tokens.expiresAt);
                                this.publishEvent(eventNames.tryKeepExistingSessionAsync_end, {
                                    success: true,
                                    message: "tokens inside storage are valid"
                                });
                                return [2 /*return*/, true];
                            case 12:
                                this.publishEvent(eventNames.tryKeepExistingSessionAsync_end, {
                                    success: false,
                                    message: serviceWorker ? "service worker sessions not retrieved" : "session storage sessions not retrieved"
                                });
                                return [2 /*return*/, false];
                            case 13:
                                exception_1 = _d.sent();
                                if (!serviceWorker) return [3 /*break*/, 15];
                                return [4 /*yield*/, serviceWorker.clearAsync()];
                            case 14:
                                _d.sent();
                                _d.label = 15;
                            case 15:
                                this.publishEvent(eventNames.tryKeepExistingSessionAsync_error, "tokens inside ServiceWorker are invalid");
                                return [2 /*return*/, false];
                            case 16: return [2 /*return*/];
                        }
                    });
                }); };
                this.tryKeepExistingSessionPromise = funcAsync();
                return [2 /*return*/, this.tryKeepExistingSessionPromise.then(function (result) {
                        _this.tryKeepExistingSessionPromise = null;
                        return result;
                    })];
            });
        });
    };
    Oidc.prototype.loginAsync = function (callbackPath, extras, installServiceWorker, state) {
        if (callbackPath === void 0) { callbackPath = undefined; }
        if (extras === void 0) { extras = null; }
        if (installServiceWorker === void 0) { installServiceWorker = true; }
        if (state === void 0) { state = undefined; }
        return __awaiter(this, void 0, void 0, function () {
            var location_1, url, configuration, serviceWorker, oidcServerConfiguration, isServiceWorkerProxyActive, storage, session, queryStringUtil, authorizationHandler, authRequest, exception_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 9, , 10]);
                        location_1 = window.location;
                        url = callbackPath || location_1.pathname + (location_1.search || '') + (location_1.hash || '');
                        this.publishEvent(eventNames.loginAsync_begin, {});
                        configuration = this.configuration;
                        // Security we cannot loggin from Iframe
                        if (!configuration.silent_redirect_uri && isInIframe()) {
                            throw new Error("Login from iframe is forbidden");
                        }
                        sessionStorage["oidc_login.".concat(this.configurationName)] = JSON.stringify({ callbackPath: url, extras: extras, state: state });
                        return [4 /*yield*/, (0, initWorker_1.initWorkerAsync)(configuration.service_worker_relative_url, this.configurationName)];
                    case 1:
                        serviceWorker = _a.sent();
                        return [4 /*yield*/, this.initAsync(configuration.authority, configuration.authority_configuration)];
                    case 2:
                        oidcServerConfiguration = _a.sent();
                        if (!(serviceWorker && installServiceWorker)) return [3 /*break*/, 4];
                        return [4 /*yield*/, serviceWorker.isServiceWorkerProxyActiveAsync()];
                    case 3:
                        isServiceWorkerProxyActive = _a.sent();
                        if (!isServiceWorkerProxyActive) {
                            window.location.href = "".concat(configuration.redirect_uri, "/service-worker-install");
                            return [2 /*return*/];
                        }
                        _a.label = 4;
                    case 4:
                        storage = void 0;
                        if (!serviceWorker) return [3 /*break*/, 7];
                        serviceWorker.startKeepAliveServiceWorker();
                        return [4 /*yield*/, serviceWorker.initAsync(oidcServerConfiguration, "loginAsync")];
                    case 5:
                        _a.sent();
                        storage = new memoryStorageBackend_1.MemoryStorageBackend(serviceWorker.saveItemsAsync, {});
                        return [4 /*yield*/, storage.setItem("dummy", {})];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        session = (0, initSession_1.initSession)(this.configurationName);
                        storage = new memoryStorageBackend_1.MemoryStorageBackend(session.saveItemsAsync, {});
                        _a.label = 8;
                    case 8:
                        queryStringUtil = configuration.redirect_uri.includes("#") ? new noHashQueryStringUtils_1.HashQueryStringUtils() : new noHashQueryStringUtils_1.NoHashQueryStringUtils();
                        authorizationHandler = new appauth_1.RedirectRequestHandler(storage, queryStringUtil, window.location, new appauth_1.DefaultCrypto());
                        authRequest = new appauth_1.AuthorizationRequest({
                            client_id: configuration.client_id,
                            redirect_uri: configuration.redirect_uri,
                            scope: configuration.scope,
                            response_type: appauth_1.AuthorizationRequest.RESPONSE_TYPE_CODE,
                            state: state,
                            extras: extras !== null && extras !== void 0 ? extras : configuration.extras
                        });
                        authorizationHandler.performAuthorizationRequest(oidcServerConfiguration, authRequest);
                        return [3 /*break*/, 10];
                    case 9:
                        exception_2 = _a.sent();
                        this.publishEvent(eventNames.loginAsync_error, exception_2);
                        throw exception_2;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    Oidc.prototype.syncTokensAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var configuration, oidcServerConfiguration, serviceWorker, tokens, silent_token_response, _a, exceptionSilent_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        configuration = this.configuration;
                        if (!this.tokens) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.initAsync(configuration.authority, configuration.authority_configuration)];
                    case 1:
                        oidcServerConfiguration = _b.sent();
                        return [4 /*yield*/, (0, initWorker_1.initWorkerAsync)(configuration.service_worker_relative_url, this.configurationName)];
                    case 2:
                        serviceWorker = _b.sent();
                        if (!serviceWorker) return [3 /*break*/, 11];
                        return [4 /*yield*/, serviceWorker.initAsync(oidcServerConfiguration, "syncTokensAsync")];
                    case 3:
                        tokens = (_b.sent()).tokens;
                        if (!!tokens) return [3 /*break*/, 11];
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 9, , 10]);
                        this.publishEvent(eventNames.syncTokensAsync_begin, {});
                        this.syncTokensAsyncPromise = this.silentSigninAsync();
                        return [4 /*yield*/, this.syncTokensAsyncPromise];
                    case 5:
                        silent_token_response = _b.sent();
                        console.log("silent_token_response");
                        console.log(silent_token_response);
                        if (!silent_token_response) return [3 /*break*/, 7];
                        _a = this;
                        return [4 /*yield*/, setTokensAsync(serviceWorker, silent_token_response)];
                    case 6:
                        _a.tokens = _b.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        this.publishEvent(eventNames.syncTokensAsync_error, null);
                        if (this.timeoutId) {
                            timer_1.default.clearTimeout(this.timeoutId);
                            this.timeoutId = null;
                        }
                        return [2 /*return*/];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        exceptionSilent_1 = _b.sent();
                        console.error(exceptionSilent_1);
                        this.publishEvent(eventNames.syncTokensAsync_error, exceptionSilent_1);
                        if (this.timeoutId) {
                            timer_1.default.clearTimeout(this.timeoutId);
                            this.timeoutId = null;
                        }
                        return [2 /*return*/];
                    case 10:
                        this.syncTokensAsyncPromise = null;
                        this.publishEvent(eventNames.syncTokensAsync_end, {});
                        _b.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    Oidc.prototype.loginCallbackAsync = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var configuration_2, clientId_1, redirectURL_1, authority, tokenRequestTimeout_1, oidcServerConfiguration_1, serviceWorker, storage_1, items, dummy, session, items, exception_3;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 10, , 11]);
                        this.publishEvent(eventNames.loginCallbackAsync_begin, {});
                        configuration_2 = this.configuration;
                        clientId_1 = configuration_2.client_id;
                        redirectURL_1 = configuration_2.redirect_uri;
                        authority = configuration_2.authority;
                        tokenRequestTimeout_1 = configuration_2.token_request_timeout;
                        return [4 /*yield*/, this.initAsync(authority, configuration_2.authority_configuration)];
                    case 1:
                        oidcServerConfiguration_1 = _b.sent();
                        return [4 /*yield*/, (0, initWorker_1.initWorkerAsync)(configuration_2.service_worker_relative_url, this.configurationName)];
                    case 2:
                        serviceWorker = _b.sent();
                        storage_1 = null;
                        if (!serviceWorker) return [3 /*break*/, 7];
                        serviceWorker.startKeepAliveServiceWorker();
                        this.serviceWorker = serviceWorker;
                        return [4 /*yield*/, serviceWorker.initAsync(oidcServerConfiguration_1, "loginCallbackAsync")];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, serviceWorker.loadItemsAsync()];
                    case 4:
                        items = _b.sent();
                        storage_1 = new memoryStorageBackend_1.MemoryStorageBackend(serviceWorker.saveItemsAsync, items);
                        return [4 /*yield*/, storage_1.getItem("dummy")];
                    case 5:
                        dummy = _b.sent();
                        if (!dummy) {
                            throw new Error("Service Worker storage disapear");
                        }
                        return [4 /*yield*/, storage_1.removeItem("dummy")];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 7:
                        this.session = (0, initSession_1.initSession)(this.configurationName, (_a = configuration_2.storage) !== null && _a !== void 0 ? _a : sessionStorage);
                        session = (0, initSession_1.initSession)(this.configurationName);
                        return [4 /*yield*/, session.loadItemsAsync()];
                    case 8:
                        items = _b.sent();
                        storage_1 = new memoryStorageBackend_1.MemoryStorageBackend(session.saveItemsAsync, items);
                        _b.label = 9;
                    case 9: return [2 /*return*/, new Promise(function (resolve, reject) {
                            // @ts-ignore
                            var queryStringUtil = new noHashQueryStringUtils_1.NoHashQueryStringUtils();
                            if (configuration_2.redirect_uri.includes("#")) {
                                var splithash = window.location.href.split("#");
                                if (splithash.length === 2 && splithash[1].includes("?")) {
                                    queryStringUtil = new noHashQueryStringUtils_1.HashQueryStringUtils();
                                }
                            }
                            // @ts-ignore
                            var authorizationHandler = new appauth_1.RedirectRequestHandler(storage_1, queryStringUtil, window.location, new appauth_1.DefaultCrypto());
                            var notifier = new appauth_1.AuthorizationNotifier();
                            authorizationHandler.setAuthorizationNotifier(notifier);
                            notifier.setAuthorizationListener(function (request, response, error) {
                                if (error) {
                                    reject(error);
                                    return;
                                }
                                if (!response) {
                                    reject("no response");
                                    return;
                                }
                                var extras = null;
                                if (request && request.internal) {
                                    extras = {};
                                    extras.code_verifier = request.internal.code_verifier;
                                    if (configuration_2.token_request_extras) {
                                        for (var _i = 0, _a = Object.entries(configuration_2.token_request_extras); _i < _a.length; _i++) {
                                            var _b = _a[_i], key = _b[0], value = _b[1];
                                            extras[key] = value;
                                        }
                                    }
                                }
                                var tokenRequest = new appauth_1.TokenRequest({
                                    client_id: clientId_1,
                                    redirect_uri: redirectURL_1,
                                    grant_type: appauth_1.GRANT_TYPE_AUTHORIZATION_CODE,
                                    code: response.code,
                                    refresh_token: undefined,
                                    extras: extras,
                                });
                                var timeoutId = setTimeout(function () {
                                    reject("performTokenRequest timeout");
                                    timeoutId = null;
                                }, tokenRequestTimeout_1 !== null && tokenRequestTimeout_1 !== void 0 ? tokenRequestTimeout_1 : 12000);
                                try {
                                    var tokenHandler = new appauth_1.BaseTokenRequestHandler(new appauth_1.FetchRequestor());
                                    tokenHandler.performTokenRequest(oidcServerConfiguration_1, tokenRequest).then(function (tokenResponse) {
                                        if (timeoutId) {
                                            var loginParams = (0, exports.getLoginParams)(_this.configurationName);
                                            clearTimeout(timeoutId);
                                            _this.timeoutId = null;
                                            _this.publishEvent(eventNames.loginCallbackAsync_end, {});
                                            resolve({
                                                tokens: tokenResponse,
                                                state: request.state,
                                                callbackPath: loginParams.callbackPath,
                                            });
                                        }
                                    });
                                }
                                catch (exception) {
                                    if (timeoutId) {
                                        clearTimeout(timeoutId);
                                        _this.timeoutId = null;
                                        _this.publishEvent(eventNames.loginCallbackAsync_error, exception);
                                        console.error(exception);
                                        reject(exception);
                                    }
                                }
                            });
                            authorizationHandler.completeAuthorizationRequestIfPossible();
                        })];
                    case 10:
                        exception_3 = _b.sent();
                        console.error(exception_3);
                        this.publishEvent(eventNames.loginCallbackAsync_error, exception_3);
                        throw exception_3;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    Oidc.prototype.refreshTokensAsync = function (refreshToken, silentEvent) {
        if (silentEvent === void 0) { silentEvent = false; }
        return __awaiter(this, void 0, void 0, function () {
            var localSilentSigninAsync, configuration, clientId, redirectUri, authority, tokenHandler, extras, _i, _a, _b, key, value, request, oidcServerConfiguration, token_response, exception_4;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        localSilentSigninAsync = function (exception) {
                            if (exception === void 0) { exception = null; }
                            return __awaiter(_this, void 0, void 0, function () {
                                var silent_token_response, exceptionSilent_2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, this.silentSigninAsync()];
                                        case 1:
                                            silent_token_response = _a.sent();
                                            if (silent_token_response) {
                                                return [2 /*return*/, silent_token_response];
                                            }
                                            return [3 /*break*/, 3];
                                        case 2:
                                            exceptionSilent_2 = _a.sent();
                                            console.error(exceptionSilent_2);
                                            return [3 /*break*/, 3];
                                        case 3:
                                            if (this.timeoutId) {
                                                timer_1.default.clearTimeout(this.timeoutId);
                                                this.timeoutId = null;
                                            }
                                            this.publishEvent(silentEvent ? eventNames.refreshTokensAsync_silent_error : eventNames.refreshTokensAsync_error, exception);
                                            return [2 /*return*/, null];
                                    }
                                });
                            });
                        };
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, , 8]);
                        this.publishEvent(silentEvent ? eventNames.refreshTokensAsync_silent_begin : eventNames.refreshTokensAsync_begin, {});
                        configuration = this.configuration;
                        clientId = configuration.client_id;
                        redirectUri = configuration.redirect_uri;
                        authority = configuration.authority;
                        if (!!refreshToken) return [3 /*break*/, 3];
                        return [4 /*yield*/, localSilentSigninAsync()];
                    case 2: return [2 /*return*/, _c.sent()];
                    case 3:
                        tokenHandler = new appauth_1.BaseTokenRequestHandler(new appauth_1.FetchRequestor());
                        extras = undefined;
                        if (configuration.token_request_extras) {
                            extras = {};
                            for (_i = 0, _a = Object.entries(configuration.token_request_extras); _i < _a.length; _i++) {
                                _b = _a[_i], key = _b[0], value = _b[1];
                                extras[key] = value;
                            }
                        }
                        request = new appauth_1.TokenRequest({
                            client_id: clientId,
                            redirect_uri: redirectUri,
                            grant_type: appauth_1.GRANT_TYPE_REFRESH_TOKEN,
                            code: undefined,
                            refresh_token: refreshToken,
                            extras: extras
                        });
                        return [4 /*yield*/, this.initAsync(authority, configuration.authority_configuration)];
                    case 4:
                        oidcServerConfiguration = _c.sent();
                        return [4 /*yield*/, tokenHandler.performTokenRequest(oidcServerConfiguration, request)];
                    case 5:
                        token_response = _c.sent();
                        this.publishEvent(silentEvent ? eventNames.refreshTokensAsync_silent_end : eventNames.refreshTokensAsync_end, { message: "success" });
                        return [2 /*return*/, token_response];
                    case 6:
                        exception_4 = _c.sent();
                        console.error(exception_4);
                        return [4 /*yield*/, localSilentSigninAsync(exception_4)];
                    case 7: return [2 /*return*/, _c.sent()];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    Oidc.prototype.loginCallbackWithAutoTokensRenewAsync = function () {
        var _this = this;
        if (this.loginCallbackWithAutoTokensRenewPromise !== null) {
            return this.loginCallbackWithAutoTokensRenewPromise;
        }
        this.loginCallbackWithAutoTokensRenewPromise = loginCallbackWithAutoTokensRenewAsync(this);
        return this.loginCallbackWithAutoTokensRenewPromise.then(function (result) {
            _this.loginCallbackWithAutoTokensRenewPromise = null;
            return result;
        });
    };
    Oidc.prototype.userInfoAsync = function () {
        return userInfoAsync(this);
    };
    Oidc.prototype.destroyAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.serviceWorker) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.serviceWorker.clearAsync()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.session) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.session.clearAsync()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.tokens = null;
                        this.userInfo = null;
                        this.events = [];
                        timer_1.default.clearTimeout(this.timeoutId);
                        this.timeoutId = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    Oidc.prototype.logoutAsync = function (callbackPathOrUrl, extras) {
        if (callbackPathOrUrl === void 0) { callbackPathOrUrl = undefined; }
        if (extras === void 0) { extras = null; }
        return __awaiter(this, void 0, void 0, function () {
            var configuration, oidcServerConfiguration, path, isUri, url, idToken, extraQueryString, _i, _a, _b, key, value;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        configuration = this.configuration;
                        return [4 /*yield*/, this.initAsync(configuration.authority, configuration.authority_configuration)];
                    case 1:
                        oidcServerConfiguration = _c.sent();
                        if (callbackPathOrUrl && (typeof callbackPathOrUrl !== 'string')) {
                            callbackPathOrUrl = undefined;
                            console.warn('callbackPathOrUrl path is not a string');
                        }
                        path = (callbackPathOrUrl === null || callbackPathOrUrl === undefined) ? location.pathname + (location.search || '') + (location.hash || '') : callbackPathOrUrl;
                        isUri = false;
                        if (callbackPathOrUrl) {
                            isUri = callbackPathOrUrl.includes("https://") || callbackPathOrUrl.includes("http://");
                        }
                        url = isUri ? callbackPathOrUrl : window.location.origin + path;
                        idToken = this.tokens ? this.tokens.idToken : "";
                        return [4 /*yield*/, this.destroyAsync()];
                    case 2:
                        _c.sent();
                        if (oidcServerConfiguration.endSessionEndpoint) {
                            extraQueryString = "";
                            if (extras) {
                                for (_i = 0, _a = Object.entries(extras); _i < _a.length; _i++) {
                                    _b = _a[_i], key = _b[0], value = _b[1];
                                    extraQueryString += "&".concat(key, "=").concat(encodeURIComponent(value));
                                }
                            }
                            window.location.href = "".concat(oidcServerConfiguration.endSessionEndpoint, "?post_logout_redirect_uri=").concat(encodeURIComponent(url), "&id_token_hint=").concat(idToken).concat(extraQueryString);
                        }
                        else {
                            window.location.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Oidc.eventNames = eventNames;
    return Oidc;
}());
exports.Oidc = Oidc;
exports.default = Oidc;
//# sourceMappingURL=oidc.js.map